import { Component, ViewEncapsulation, Input } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { v_InvoiceGridSearchBus } from '@app/cp/shared/models/v_InvoiceGridSearchBus';

@Component({
    selector: 'invoice-search-grid',
    templateUrl: './invoice-search-grid.component.html',
    styleUrls: ['./invoice-search-grid.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InvoiceSearchGridComponent extends BaseGridUIComponent<v_InvoiceGridSearchBus, null, DQOIService> {

    constructor(globals: GlobalsService, svc_data: DQOIService) {
        super(globals);
        this.svc_data = svc_data;
    }
    @Input() searchText: string = "";

}
